import styled from 'styled-components'
import { MenLogoPlainIcon } from '@velasca/icons/men-logo-plain'
import { MenSmallLogoPlainIcon } from '@velasca/icons/men-small-logo-plain'
import { WomenLogoPlainIcon } from '@velasca/icons/women-logo-plain'
import { WomenSmallLogoPlainIcon } from '@velasca/icons/women-small-logo-plain'
import { isWoman } from '@velasca/utils/globals'

export const Extended = styled(
  isWoman ? WomenLogoPlainIcon : MenLogoPlainIcon,
)<{
  variant?: 'primary' | 'white'
}>`
  path {
    stroke: ${({ theme, variant = 'primary' }) => theme.logo[variant]};
    fill: ${({ theme, variant = 'primary' }) => theme.logo[variant]};
  }
`

export const Short = styled(
  isWoman ? WomenSmallLogoPlainIcon : MenSmallLogoPlainIcon,
)<{
  variant?: 'primary' | 'white'
}>`
  path {
    stroke: ${({ theme, variant = 'primary' }) => theme.logo[variant]};
    fill: ${({ theme, variant = 'primary' }) => theme.logo[variant]};
  }
`
